"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deferred = exports.formatNumber = exports.withDefault = exports.imageSize = exports.firestoreData = exports.firestoreDataFromSnap = exports.modelFromSnap = exports.modelsFromQuerySnap = exports.shallowTSToDates = exports.formatFSDT = exports.formatShortDate = exports.formatSanitizedDate = exports.formatDate = exports.formatTime = exports.formatDateTime = exports.firestoreTsToDate = exports.dateToFirestoreTs = exports.copyCollection = exports.firestoreCollectionWithRefs = exports.deleteCollection = exports.isServer = void 0;
var app_1 = require("firebase/app");
require("firebase/firestore");
var browser_or_node_1 = require("browser-or-node");
var date_fns_1 = require("date-fns");
var lodash_1 = require("lodash");
var date_fns_tz_1 = require("date-fns-tz");
exports.isServer = !browser_or_node_1.isBrowser;
function deleteCollection(firestore, collectionName) {
    return __awaiter(this, void 0, void 0, function () {
        var documents;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firestore.collection(collectionName).get()];
                case 1:
                    documents = _a.sent();
                    console.log("TODO delete collection", { documents: documents });
                    return [2 /*return*/];
            }
        });
    });
}
exports.deleteCollection = deleteCollection;
var firestoreCollectionWithRefs = function (q) {
    return (q &&
        q.docs.map(function (doc) {
            return (__assign(__assign({}, (0, exports.shallowTSToDates)(doc.data())), { id: doc.id, ref: doc.ref }));
        })) ||
        [];
};
exports.firestoreCollectionWithRefs = firestoreCollectionWithRefs;
// from https://stackoverflow.com/a/60137639/65311
function copyCollection(firestore, srcCollectionName, destCollectionName) {
    return __awaiter(this, void 0, void 0, function () {
        var documents, writeBatch, destCollection, i, _i, _a, doc;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, firestore.collection(srcCollectionName).get()];
                case 1:
                    documents = _b.sent();
                    writeBatch = firestore.batch();
                    destCollection = firestore.collection(destCollectionName);
                    i = 0;
                    _i = 0, _a = documents.docs;
                    _b.label = 2;
                case 2:
                    if (!(_i < _a.length)) return [3 /*break*/, 5];
                    doc = _a[_i];
                    writeBatch.set(destCollection.doc(doc.id), doc.data());
                    i++;
                    if (!(i > 400)) return [3 /*break*/, 4];
                    // write batch only allows maximum 500 writes per batch
                    i = 0;
                    console.log("Intermediate committing of batch operation");
                    return [4 /*yield*/, writeBatch.commit()];
                case 3:
                    _b.sent();
                    writeBatch = firestore.batch();
                    _b.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 2];
                case 5:
                    if (!(i > 0)) return [3 /*break*/, 7];
                    console.log("Firebase batch operation completed. Doing final committing of batch operation.");
                    return [4 /*yield*/, writeBatch.commit()];
                case 6:
                    _b.sent();
                    return [3 /*break*/, 8];
                case 7:
                    console.log("Firebase batch operation completed.");
                    _b.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    });
}
exports.copyCollection = copyCollection;
var dateToFirestoreTs = function (date) {
    return app_1.default.firestore.Timestamp.fromDate(date);
};
exports.dateToFirestoreTs = dateToFirestoreTs;
var firestoreTsToDate = function (_a) {
    var seconds = _a.seconds, _seconds = _a._seconds, nanoseconds = _a.nanoseconds;
    return new app_1.default.firestore.Timestamp(seconds || _seconds || 0, nanoseconds).toDate();
};
exports.firestoreTsToDate = firestoreTsToDate;
var formatDateTime = function (dt, fmt) {
    if (fmt === void 0) { fmt = "Pp"; }
    return (0, date_fns_1.format)(dt, fmt);
};
exports.formatDateTime = formatDateTime;
var formatTime = function (dt) { return (0, date_fns_1.format)(dt, "p"); };
exports.formatTime = formatTime;
var formatDate = function (dt) { return (0, date_fns_1.format)(dt, "P"); };
exports.formatDate = formatDate;
// NOTE: this is formatted in UTC
var formatSanitizedDate = function (dt) {
    return (0, date_fns_tz_1.formatInTimeZone)(dt, "UTC", "yyyyMMdd");
};
exports.formatSanitizedDate = formatSanitizedDate;
var formatShortDate = function (dt) { return (0, date_fns_1.format)(dt, "L/d"); };
exports.formatShortDate = formatShortDate;
var formatFSDT = function (ts) {
    return (0, exports.formatDateTime)((0, exports.firestoreTsToDate)(ts));
};
exports.formatFSDT = formatFSDT;
// for every value in a map, if the value looks like a Firestore Timestamp,
// convert it to a JS Date
// gross TS gymanstics. someday figure out how to do it right. Basically we want
// to take any model (T) and convert any values on it that look like Firestore
// Timestamps.
var shallowTSToDates = function (object) {
    return (0, lodash_1.mapValues)(object, function (v) {
        return (0, lodash_1.isNumber)(v === null || v === void 0 ? void 0 : v.seconds) && (0, lodash_1.isNumber)(v === null || v === void 0 ? void 0 : v.nanoseconds)
            ? (0, exports.firestoreTsToDate)(v)
            : v;
    });
};
exports.shallowTSToDates = shallowTSToDates;
var modelsFromQuerySnap = function (querySnap) { return querySnap.docs.map(function (d) { return (0, exports.modelFromSnap)(d); }); };
exports.modelsFromQuerySnap = modelsFromQuerySnap;
// snap is a DocumentSnapshot or QueryDocumentSnapshot but TS complains about
// the types, so stub it out ourselves
var modelFromSnap = function (snap) {
    return (__assign(__assign({}, (0, exports.shallowTSToDates)(snap.data())), { ref: snap.ref, id: snap.id }));
};
exports.modelFromSnap = modelFromSnap;
/** @deprecated
 * Use `modelFromSnap` instead
 * */
var firestoreDataFromSnap = function (snap) {
    return (__assign(__assign({}, (0, exports.shallowTSToDates)(snap.data())), { id: snap.id, ref: snap.ref }));
};
exports.firestoreDataFromSnap = firestoreDataFromSnap;
// given a ref and a type that represents some model, return the document data
// as the type and convert firestore timestamps to Dates
var firestoreData = function (ref) { return __awaiter(void 0, void 0, void 0, function () {
    var snap;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ref.get()];
            case 1:
                snap = _a.sent();
                return [2 /*return*/, (0, exports.modelFromSnap)(snap)];
        }
    });
}); };
exports.firestoreData = firestoreData;
// supports:
// 600
// 1000
// 1500
// images%2Factivities%2Fx%2FAdultCoEdSoccer%20Parks%20Rec_1000x1000.webp?alt=media
// images%2Factivities%2FPioneer%20Park%20Tennis.JPG?alt=media
var supportedSizes = {
    600: 600,
    1000: 1000,
    1500: 1500,
};
var imageSize = function (imageUrl, size) {
    // make sure the passed in image url is defined
    if (!imageUrl) {
        // console.warn("imageSize imageUrl is undefined", { imageUrl });
        return;
    }
    // make sure the passed in image url is a firebase storage url (which supports
    // sizes)
    if (!imageUrl.startsWith("https://firebasestorage.googleapis.com")) {
        // console.debug(
        //   "imageSize imageUrl is not a firebase url, and therefore does not support sizes",
        //   { imageUrl }
        // );
        return imageUrl;
    }
    if (size in supportedSizes) {
        var url = new URL(imageUrl);
        var pathname = url.pathname;
        // split the encoded segment out of the path
        var _a = pathname.split(/(.*)\//), basePath = _a[1], encodedPath = _a[2];
        var _b = decodeURIComponent(encodedPath).split(
        /* eslint-disable */
        /\/(?=[^\/]+$)/), decodedPath = _b[0], filename = _b[1];
        var file = filename.split(/\.(\w+$)/)[0];
        var newFile = "".concat(file, "_").concat(size, "x").concat(size, ".webp");
        var newPathSegment = "".concat(decodedPath, "/x/").concat(newFile);
        url.pathname = "".concat(basePath, "/").concat(encodeURIComponent(newPathSegment));
        return url.toString();
    }
    else {
        console.warn("imageSize size is not supported, returning imageUrl as is", {
            imageUrl: imageUrl,
            size: size,
            supportedSizes: supportedSizes,
        });
        return imageUrl;
    }
};
exports.imageSize = imageSize;
var withDefault = function (val, def) {
    return val === undefined || val === null ? def : val;
};
exports.withDefault = withDefault;
var numberFormat = new Intl.NumberFormat();
var formatNumber = function (n) { return numberFormat.format(n); };
exports.formatNumber = formatNumber;
// from https://stackoverflow.com/a/69027809/65311
// usage:
//
// const {promise, resolve} = deferred<string>();
// promise.then((value) => console.log(value)); // nothing
// resolve('foo'); // console.log: foo
var deferred = function () {
    var resolve;
    var reject;
    var promise = new Promise(function (res, rej) {
        resolve = res;
        reject = rej;
    });
    return {
        resolve: resolve,
        reject: reject,
        promise: promise,
    };
};
exports.deferred = deferred;
//# sourceMappingURL=util.js.map